import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { APP_ROUTES } from "../app.routes.definition";

export const ExpiredInitialSurveyGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree => {
    const router = inject(Router);
    const previousUrl = router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();

    return previousUrl?.startsWith(APP_ROUTES.MARKETPLACE()) ? true : router.createUrlTree([APP_ROUTES.HOME()]);
};
